<template>
    <form action="#" method="POST" @submit.prevent="validaAlteracoes">
        <div class="row">
            <vc-mostra-mensagem-validacao></vc-mostra-mensagem-validacao>
        </div>

        <div class="row">
            <div class="col-xs-12">
                <vc-form-pessoa></vc-form-pessoa>
            </div>
        </div>

        <div class="row" v-if="!editando">
            <div class="col-xs-12">
                <button type="button" class="btn btn-info btn-xs pull-left" @click="exibeFormBuscaAnalise.sistemaAntigo = !exibeFormBuscaAnalise.sistemaAntigo" v-if="analise.tipo.value == 'SOLO'">
                    <i class="fa fa-plus"></i> Carregar dados
                </button>

                <button type="button" class="btn btn-info btn-xs pull-left" style="margin-left: 10px;" @click="exibeFormBuscaAnalise.site = !exibeFormBuscaAnalise.site">
                    <i class="fa fa-plus"></i> Carregar dados site
                </button>
                <br><br>

                <div class="block" v-if="exibeFormBuscaAnalise.sistemaAntigo && analise.tipo.value == 'SOLO'">
                    <div class="block-title">
                        <h3>Buscar dados de Análise</h3>
                    </div>

                    <div class="row">
                        <div class="col-xs-12 col-sm-4">
                            <div class="form-group">
                                <div class="row">
                                    <div class="col-xs-6 col-sm-4">
                                        <input type="text" class="form-control"
                                               v-model="analiseSistemaAntigo.numeroRegistro" placeholder="Registro"
                                               size="10"/>
                                    </div>
                                    <div class="col-xs-6 col-sm-4">
                                        <the-mask mask="####" type="text" :masked="true"
                                                  v-model="analiseSistemaAntigo.numeroRegistroAno" placeholder="Ano"
                                                  class="form-control"></the-mask>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-xs-12 col-sm-4">
                            <div class="form-group">
                                <button type="button" @click="buscaAnaliseSistemaAntigo" class="btn btn-success">
                                    Buscar
                                </button>&nbsp;
                                <button type="button" class="btn btn-danger"
                                        @click="exibeFormBuscaAnalise.sistemaAntigo = !exibeFormBuscaAnalise.sistemaAntigo">Fechar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="block" v-if="exibeFormBuscaAnalise.site">
                    <div class="block-title">
                        <h3>Buscar dados de Análise</h3>
                    </div>

                    <div class="row">
                        <div class="col-xs-12 col-sm-4">
                            <div class="form-group">
                                <div class="row">
                                    <div class="col-xs-12 col-sm-12">
                                        <input type="text" class="form-control"
                                               v-model="analiseSistemaAntigo.codigoSite" placeholder="Código site"
                                               size="10"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-xs-12 col-sm-4">
                            <div class="form-group">
                                <button type="button" @click="buscaAnaliseSite" class="btn btn-success">
                                    Buscar
                                </button>&nbsp;
                                <button type="button" class="btn btn-danger"
                                        @click="exibeFormBuscaAnalise.site = !exibeFormBuscaAnalise.site">Fechar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="panel">
            <div class="panel-body">
                <div class="row">
                    <div class="col-xs-12">
                        <vc-pesquisa
                                @input="selecinouRemetente"
                                :extra="extraRemetente"
                                label="Remetente"
                                nome-input="remetente_id"
                                :selecionado="analise.remetente"
                                url-busca="api/pessoas/pesquisa"
                                :selecionado-config="{label: 'nomerazao_social', campo: 'id'}"
                                :campos-table="[ {'label' : 'Nome', 'campo' : 'nomerazao_social'}, {'label' : 'CPF/CNPJ', 'campo' : 'cpfcnpj'}]"
                                :obrigatorio="true">
                        </vc-pesquisa>
                    </div>
                </div>

                <div class="row">
                    <div class="col-xs-12 col-sm-4">
                        <div class="form-group" :class="{'has-error': errors.has('data registro')}">
                            <label>Data de registro</label>
                            <Datepicker v-model="analise.data_registro" :value="analise.data_registro"
                                        v-validate="{required: true}" data-vv-name="data registro"/>
                        </div>
                    </div>
                </div>

                <div class="row" v-if="analise.tipo.value == 'SOLO'">
                    <div class="col-xs-12 col-sm-4">
                        <div class="form-group">
                            <label>Laudo para financiamento?</label>
                            <v-select
                                    v-model="analise.laudo_financiamento"
                                    :options="[
                                          {value: '1',label: 'Sim'},
                                          {value: '0',label: 'Não'}
                                        ]"
                            ></v-select>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="panel" v-if="podeEditarPagamentos">
            <div class="panel-body">
                <div class="row">
                    <div class="col-xs-12">
                        <label>Selecione uma forma de pagamento</label>
                    </div>
                    <div class="col-xs-6 col-sm-4">
                        <div class="form-group">
                            <label class="switch switch-success"><input type="checkbox"
                                                                        v-model="documento.FATURADA"><span></span></label>&nbsp;À
                            vista
                        </div>
                    </div>
                    <div class="col-xs-6 col-sm-4">
                        <div class="form-group">
                            <label class="switch switch-success"><input type="checkbox"
                                                                        v-model="documento.NFATURAR"><span></span></label>&nbsp;À
                            prazo
                        </div>
                    </div>
                    <div class="col-xs-6 col-sm-4" v-if="$store.state.Form.toEdit == null || ($store.state.Form.toEdit != null && $store.state.Form.toEdit.forma_pagamento != 'BOLETO')">
                        <div class="form-group">
                            <label class="switch switch-success"><input type="checkbox"
                                                                        v-model="documento.BOLETO"><span></span></label>&nbsp;Boleto
                            bancário
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div v-if="documento.BOLETO">
                        <div class="col-xs-12 col-sm-4">
                            <div class="form-group">
                                <label>Boleto para</label>
                                <v-select
                                        v-model="analise.boleto"
                                        v-validate="{required: true}"
                                        :options="[{value: 'REMETENTE',label: 'Remetente'}, {value: 'PROPRIETARIO',label: 'Produtor / Proprietário'}, {value: 'ARRENDATARIO',label: 'Proprietário / Cedente'}]"
                                        data-vv-name="enviar boleto"
                                ></v-select>
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-4">
                            <div class="form-group">
                                <label>Gerar boleto no</label>
                                <v-select
                                        v-model="analise.gera_boleto"
                                        v-validate="{required: true}"
                                        :options="[{value: 'RESULTADO',label: 'Resultado'}, {value: 'PROTOCOLO',label: 'Protocolo'}]"
                                        data-vv-name="enviar boleto"
                                ></v-select>
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-4"
                             v-if="analise.gera_boleto != undefined && analise.gera_boleto.value == 'PROTOCOLO'">
                            <div class="form-group" :class="{'has-error': errors.has('vencimento')}">
                                <label>Vencimento</label>
                                <Datepicker :value="analise.data_vencimento" v-model="analise.data_vencimento"
                                            v-validate="'required'" data-vv-name="vencimento"/>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-xs-12 col-sm-4" v-if="analise.tipo.value === 'SOLO'">
                        <div class="form-group">
                            <label class="switch switch-success"><input type="checkbox"
                                                                        v-model="subsidio.alterou" :checked="subsidio.alterou"><span></span></label>&nbsp;Subsídio Laboratório
                        </div>
                    </div>

                    <div class="col-xs-12 col-sm-4" v-if="analise.tipo.value === 'SOLO'">
                        <div class="form-group">
                            <label class="switch switch-success"><input type="checkbox"
                                                                        v-model="subsidio_sebrae.alterou" :checked="subsidio_sebrae.alterou"><span></span></label>&nbsp;Subsídio SEBRAE
                        </div>
                    </div>

                    <div class="col-xs-12 col-sm-4" v-if="analise.tipo.value === 'SOLO' && analise.registro == 0 && analise.ano_registro == 0 && subsidio_temp">
                        <div class="form-group">
                            <label class="text-danger">** Selecione um subsídio **</label>
                        </div>
                    </div>

                    <div class="col-xs-12 col-sm-4" v-if="!documento.NFATURAR && (documento.BOLETO || documento.FATURADA)">
                        <label>Nota Fiscal de Serviço</label>
                        <div class="form-group">
                            <label class="switch switch-success"><input type="checkbox"
                                                                        v-model="analise.emitir_nota"><span></span></label>&nbsp;Emitir
                            NFS-e
                        </div>
                    </div>

                    <div class="col-xs-6 col-sm-4" v-if="!documento.NFATURAR && (documento.BOLETO || documento.FATURADA) && analise.emitir_nota && analise.documento != 'BOLETO'">
                        <div class="form-group">
                            <label>NFS-e para</label>
                            <v-select
                                    v-model="analise.nfse_para"
                                    v-validate="{required: true}"
                                    :options="[{value: 'REMETENTE',label: 'Remetente'}, {value: 'PROPRIETARIO',label: 'Proprietário / Cedente'}, {value: 'ARRENDATARIO',label: 'Produtor'}]"
                                    data-vv-name="enviar boleto"
                            ></v-select>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="panel">
            <div class="panel-body">
                <div class="row">
                    <div class="col-xs-12 col-sm-4">
                        <div class="form-group" :class="{'has-error': errors.has('tipo')}">
                            <label>Material a ser analisado?</label>
                            <v-select
                                    v-model="analise.tipo"
                                    :disabled="!podeEditarPagamentos"
                                    :options="[{value: 'SOLO',label: 'Solo'},{value: 'SEMENTE',label: 'Semente'},{value: 'TECIDO',label: 'Tecido vegetal'},{value: 'FERTILIZANTE',label: 'Fertilizante'}]"
                                    data-vv-name="tipo"
                            ></v-select>
                        </div>
                    </div>

                    <div class="col-xs-12 col-sm-4">
                        <div class="form-group" :class="{'has-error': errors.has('valor')}">
                            <label>Valor da amostra (R$)</label>
                            <money
                                    v-model="analise.valor_amostra"
                                    class="form-control"
                                    :disabled="true"
                                    data-vv-name="valor"
                            ></money>
                        </div>
                    </div>

                    <div class="col-xs-12 col-sm-4">
                        <div class="form-group" :class="{'has-error': errors.has('previsão')}">
                            <label>Previsão de conclusão</label>
                            <Datepicker :value="analise.data_previsao_conclusao"
                                        v-model="analise.data_previsao_conclusao" v-validate="'required'"
                                        data-vv-name="previsão"/>
                        </div>
                    </div>
                </div>

                <div v-if="analise.tipo.value === 'SOLO' || analise.tipo.value === 'SEMENTE' || analise.tipo.value === 'FERTILIZANTE'">
                    <div class="row">
                        <div v-if="analise.tipo.value === 'SOLO'">
                            <div class="col-xs-12">
                                <label>Tipo de amostra de solo</label>
                            </div>
                            <div class="col-xs-6 col-sm-4">
                                <div class="form-group">
                                    <label class="switch switch-success"><input type="checkbox"
                                                                                v-model="analise.solo_quimica"
                                                                                :disabled="!podeEditarPagamentos"
                                                                                @change="aplicarTabela"><span></span></label>&nbsp;Química
                                </div>
                            </div>
                            <div class="col-xs-6 col-sm-4">
                                <div class="form-group">
                                    <label class="switch switch-success"><input type="checkbox"
                                                                                v-model="analise.solo_fisica"
                                                                                :disabled="!podeEditarPagamentos"
                                                                                @change="aplicarTabela"><span></span></label>&nbsp;Física
                                </div>
                            </div>
                            <div class="col-xs-6 col-sm-4">
                                <div class="form-group">
                                    <label class="switch switch-success"><input type="checkbox"
                                                                                v-model="analise.solo_extrato_saturacao"
                                                                                :disabled="!podeEditarPagamentos"
                                                                                @change="aplicarTabela"><span></span></label>&nbsp;Extrato
                                    de saturação
                                </div>
                            </div>

                            <div class="col-xs-6 col-sm-4" v-if="analise.id_coleta_app != undefined && analise.id_coleta_app != null">
                                <div class="form-group">
                                    <label class="switch switch-success">
                                        <input type="checkbox" disabled="true" value="1" checked><span></span>
                                    </label>&nbsp; Agricultura de precisão
                                </div>
                            </div>
                            <!--<div class="col-xs-6 col-md-3">-->
                            <!--<div class="form-group">-->
                            <!--<label class="switch switch-success"><input type="checkbox" v-model="analise.solo_metais_pesados" @change="aplicarTabela"><span></span></label>&nbsp;Metais pesados-->
                            <!--</div>-->
                            <!--</div>-->

                            <div class="col-xs-12 col-sm-12" v-if="analise.solo_quimica">
                                <div class="form-group">
                                    <label class="switch switch-success">
                                        <input type="checkbox"
                                            v-model="analise.pacote_elementos_1"
                                            @change="changeElementos1"><span></span></label>&nbsp; Analise de todos os novos elementos
                                </div>
                            </div>

                            <div class="col-xs-6 col-sm-4" v-if="analise.solo_quimica">
                                <div class="form-group">
                                    <label class="switch switch-success">
                                        <input type="checkbox"
                                            v-model="analise.analisa_ph_calc2"
                                            @change="verificaElementos1"><span></span></label>&nbsp; Analise de PH (calc2)
                                </div>
                            </div>

                            <div class="col-xs-6 col-sm-4" v-if="analise.solo_quimica">
                                <div class="form-group">
                                    <label class="switch switch-success">
                                        <input type="checkbox"
                                            v-model="analise.analisa_fosforo_resina"
                                            @change="verificaElementos1"><span></span></label>&nbsp; Analise de fosforo (resina)
                                </div>
                            </div>

                            <div class="col-xs-6 col-sm-4" v-if="analise.solo_quimica">
                                <div class="form-group">
                                    <label class="switch switch-success">
                                        <input type="checkbox"
                                            v-model="analise.analisa_ferro"
                                            @change="verificaElementos1"><span></span></label>&nbsp; Analise de ferro
                                </div>
                            </div>

                            <div class="col-xs-6 col-sm-4" v-if="analise.solo_quimica">
                                <div class="form-group">
                                    <label class="switch switch-success">
                                        <input type="checkbox"
                                            v-model="analise.analisa_condutividade"
                                            @change="verificaElementos1"><span></span></label>&nbsp; Analise de condutividade
                                </div>
                            </div>

                            <div class="col-xs-6 col-sm-4" v-if="analise.solo_quimica">
                                <div class="form-group">
                                    <label class="switch switch-success">
                                        <input type="checkbox"
                                            v-model="analise.analisa_nitrogenio_azoto"
                                            @change="verificaElementos1"><span></span></label>&nbsp; Analise de Nitrogenio (azoto)
                                </div>
                            </div>

                            <div class="col-xs-6 col-sm-4" v-if="analise.solo_quimica">
                                <div class="form-group">
                                    <label class="switch switch-success">
                                        <input type="checkbox"
                                            v-model="analise.analisa_silicio"
                                            @change="verificaElementos1"><span></span></label>&nbsp; Analise de silicio
                                </div>
                            </div>
                        </div>

                        <div v-if="analise.tipo.value === 'SEMENTE'">
                            <div class="col-xs-12">
                                <label>Tipo de amostra de semente</label>
                            </div>
                            <div class="col-xs-6 col-sm-4">
                                <div class="form-group">
                                    <label class="switch switch-success"><input type="checkbox"
                                                                                v-model="analise.semente_germinacao"
                                                                                :disabled="!podeEditarPagamentos"
                                                                                @change="aplicarTabela"><span></span></label>&nbsp;Germinação
                                </div>
                            </div>
                            <div class="col-xs-6 col-sm-4">
                                <div class="form-group">
                                    <label class="switch switch-success"><input type="checkbox"
                                                                                v-model="analise.semente_vigor"
                                                                                :disabled="!podeEditarPagamentos"
                                                                                @change="aplicarTabela"><span></span></label>&nbsp;Vigor
                                </div>
                            </div>
                        </div>

                        <div v-if="analise.tipo.value === 'FERTILIZANTE'">
                            <div class="col-xs-12">
                                <label>Tipo de amostra de fertilizante</label>
                            </div>
                            <div class="col-xs-6 col-sm-4">
                                <div class="form-group">
                                    <label class="switch switch-success"><input type="checkbox" v-model="analise.fertilizante_mineral" :disabled="!podeEditarPagamentos"
                                                                                @change="aplicarTabela"><span></span></label>&nbsp;Mineral
                                </div>
                            </div>
                            <div class="col-xs-6 col-sm-4">
                                <div class="form-group">
                                    <label class="switch switch-success"><input type="checkbox" v-model="analise.fertilizante_organico" :disabled="!podeEditarPagamentos"
                                                                                @change="aplicarTabela"><span></span></label>&nbsp;Orgânico
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="panel">
            <div class="panel-body">
                <div class="row">
                    <div class="col-xs-12">
                        <vc-form-pessoa></vc-form-pessoa>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12">
                        <vc-adiciona-pessoa
                                :tipo="analise.tipo.value"
                                @setArrendatarios="arr => arrendatarios = arr "
                                @setProprietarios="prop => proprietarios = prop "
                                :proprietarios="proprietarios"
                                :arrendatarios="arrendatarios">
                        </vc-adiciona-pessoa>
                    </div>
                </div>

                <div class="row">
                    <div v-if="analise.tipo.value === 'SOLO'">
                        <div class="col-xs-12 col-sm-4">
                            <div class="form-group" :class="{'has-error': errors.has('localidade')}">
                                <label>Localidade da amostra *</label>
                                <input type="text" v-model="analise.solo.localidade"
                                       v-validate="( analise.tipo.value === 'SOLO' && parseInt(analise.laudo_financiamento.value) ) ? 'required' : ''"
                                       class="form-control" data-vv-name="localidade"/>
                            </div>
                        </div>
                    </div>

                    <div class="col-xs-12 col-sm-4">
                        <vc-pesquisa
                                @input="setCidade"
                                label="Município da amostra *"
                                nome-input="cidade_id"
                                :selecionado-config="{label : 'nome', campo : 'id'}"
                                :selecionado="analise.cidade"
                                url-busca="api/cidades/pesquisa"
                                :campos-table="[ {'label' : 'Nome', 'campo' : 'nome'}, {'label' : 'Código IBGE', 'campo' : 'codigo_ibge'}]"
                                obrigatorio="cidade"
                        ></vc-pesquisa>
                    </div>
                </div>
            </div>
        </div>

        <div v-show="analise.tipo.value === 'SOLO'">
            <div class="panel">
                <div class="panel-body">
                    <div class="row">
                        <div class="col-xs-12 col-sm-4">
                            <div class="form-group" :class="{'has-error': errors.has('hectares da escritura')}">
                                <label>Hectares da escritura *</label>
                                <input type="text" onClick="this.select();" v-model="analise.solo.area_ha"
                                       class="form-control"
                                       v-validate="( analise.tipo.value === 'SOLO' && parseInt(analise.laudo_financiamento.value) ) ? 'required' : ''"
                                       data-vv-name="hectares da escritura"/>
                            </div>
                        </div>

                        <div class="col-xs-12 col-sm-4">
                            <div class="form-group" :class="{'has-error': errors.has('matrícula')}">
                                <label>Matrícula *</label>
                                <input type="text" v-model="analise.solo.matricula" class="form-control"
                                       v-validate="( analise.tipo.value === 'SOLO' && parseInt(analise.laudo_financiamento.value) ) ? 'required' : ''"
                                       data-vv-name="matrícula" maxlength="30"/>
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-4">
                            <div class="form-group">
                                <label>Lote rural</label>
                                <input type="text" v-model="analise.solo.lote_rural" class="form-control"
                                       maxlength="30">
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-xs-12 col-sm-4">
                            <div class="form-group">
                                <label>Referência cliente</label>
                                <input type="text" v-model="analise.solo.referencia_cliente" class="form-control"
                                       maxlength="20">
                            </div>
                        </div>

                        <div class="col-xs-12 col-sm-4">
                            <div class="form-group">
                                <label>Altitude</label>
                                <input type="text" v-model="analise.solo.altitude" class="form-control">
                            </div>
                        </div>

                        <div class="col-xs-12 col-sm-4">
                            <div class="form-group">
                                <label>Latitude</label>
                                <input type="text" v-model="analise.solo.latitude" class="form-control">
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-xs-12 col-sm-4">
                            <div class="form-group">
                                <label>Longitude</label>
                                <input type="text" v-model="analise.solo.longitude" class="form-control">
                            </div>
                        </div>

                        <div class="col-xs-12 col-sm-4">
                            <div class="form-group">
                                <label>Profundidade inicial da coleta (cm)</label>
                                <input @input="positivosApenasInicial" type="text" v-model="analise.solo.profundidade_coleta_inicial" class="form-control">
                            </div>
                        </div>

                        <div class="col-xs-12 col-sm-4">
                            <div class="form-group">
                                <label>Profundidade final da coleta (cm)</label>
                                <input @input="positivosApenasFinal" type="text" v-model="analise.solo.profundidade_coleta_final" class="form-control">
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <!--<div class="col-xs-12 col-sm-4">
                            <vc-pesquisa
                                    @input="(cultura) => analise.cultura_id = cultura.id"
                                    :extra="extraCultura"
                                    label="Cultura"
                                    nome-input="cultura_id"
                                    :selecionado-config="{label : 'nome', campo : 'id'}"
                                    :selecionado="analise.cultura"
                                    url-busca="api/culturas/pesquisa"
                                    :campos-table="[ {'label' : 'Nome', 'campo' : 'nome'}, {'label' : 'Tipo', 'campo' : 'tipo'}]"
                            ></vc-pesquisa>
                        </div>-->

                        <div class="col-xs-12 col-sm-4">
                            <div class="form-group">
                                <label>Cultura(s)</label>
                                <input type="text" v-model="analise.cultura_solo" class="form-control">
                            </div>
                        </div>

                        <div class="col-xs-12 col-sm-4">
                            <div class="form-group">
                                <label>Responsável técnico</label>
                                <input type="text" v-model="analise.responsavel_tecnico" class="form-control">
                            </div>
                        </div>

                        <div class="col-xs-12 col-sm-4" style="height: 75px; /*firefox bug*/">
                            <div class="form-group">
                                <label>Foto</label>
                                <input type="file" @change="setFoto($event)">
                            </div>
                        </div>

                    </div>

                    <div class="row">
                        <div class="col-xs-12 col-sm-12" v-if="editando && analise.subsidio_sebrae == '1'">
                            <div class="form-group">
                                <label>Análises com mesma autorização (Sebrae)</label>
                                <VueSelect
                                    v-model="analise.analises_sebrae"
                                    :options="analisesProprietarioSebrae"
                                    :multiple="true"><span slot="no-options">Nenhum registro localizado.</span>
                                </VueSelect>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="analise.tipo.value === 'SEMENTE'">
            <div class="panel">
                <div class="panel-body">
                    <div class="row">
                        <div class="col-xs-12 col-sm-4">
                            <div class="form-group" :class="{'has-error': errors.has('amostra')}">
                                <label>Amostra *</label>
                                <input type="text" v-model="analise.semente.amostra" class="form-control"
                                       v-validate="'required'" data-vv-name="amostra"/>
                            </div>
                        </div>

                        <div class="col-xs-12 col-sm-4">
                            <div class="form-group" :class="{'has-error': errors.has('lote')}">
                                <label>Lote *</label>
                                <input type="text" v-model="analise.semente.lote" class="form-control"
                                       v-validate="'required'" data-vv-name="lote"/>
                            </div>
                        </div>

                        <div class="col-xs-12 col-sm-4">
                            <div class="form-group" :class="{'has-error': errors.has('safra')}">
                                <label>Safra *</label>
                                <input type="text" v-model="analise.semente.safra" class="form-control"
                                       v-validate="'required'" data-vv-name="safra"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="analise.tipo.value == 'TECIDO'">
            <div class="panel">
                <div class="panel-body">
                    <div class="row">
                        <div class="col-xs-12 col-sm-4">
                            <vc-pesquisa
                                    @input="(cultura) => preencheCultura(cultura)"
                                    :extra="extraCultura"
                                    label="Cultura *"
                                    nome-input="cultura_id"
                                    :selecionado-config="{label : 'nome', campo : 'id'}"
                                    :selecionado="analise.cultura"
                                    url-busca="api/culturas/pesquisa"
                                    :campos-table="[ {'label' : 'Nome', 'campo' : 'nome'}, {'label' : 'Tipo', 'campo' : 'tipo'}]"
                                    :obrigatorio="(analise.tipo.value == 'TECIDO' ? 'cultura' : null)"
                            ></vc-pesquisa>
                        </div>

                        <div class="col-xs-12 col-sm-4">
                            <div class="form-group" :class="{'has-error': errors.has('referência')}">
                                <label>Referência *</label>
                                <input type="text" v-model="analise.tecido.referencia" class="form-control"
                                       v-validate="'required'" data-vv-name="referência">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="analise.tipo.value === 'FERTILIZANTE'">
            <div class="panel">
                <div class="panel-body">
                    <div class="row">
                        <div class="col-xs-12 col-sm-4">
                            <div class="form-group">
                                <label>Referência</label>
                                <input type="text" onClick="this.select();" v-model="analise.fertilizante.referencia"
                                       class="form-control" data-vv-name="refêrencia"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="panel">
                <div class="panel-body">
                    <div class="row">
                        <div class="col-xs-12 col-sm-4">
                            <div class="form-group" :class="{'has-error': errors.has('nitrogênio')}">
                                <label>Nitrogênio (%) *</label>
                                <input type="text" onClick="this.select();" v-model="analise.fertilizante.nitrogenio"
                                       class="form-control" v-validate="{required: true}" data-vv-name="nitrogênio"/>
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-4">
                            <div class="form-group" :class="{'has-error': errors.has('fósforo')}">
                                <label>Fósforo (%) *</label>
                                <input type="text" onClick="this.select();" v-model="analise.fertilizante.fosforo"
                                       class="form-control" v-validate="{required: true}" data-vv-name="fósforo"/>
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-4">
                            <div class="form-group" :class="{'has-error': errors.has('potássio')}">
                                <label>Potássio (%) *</label>
                                <input type="text" onClick="this.select();" v-model="analise.fertilizante.potassio"
                                       class="form-control" v-validate="{required: true}" data-vv-name="potássio"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="panel">
            <div class="panel-body">
                <div class="row">
                    <div class="col-xs-12 col-sm-4">
                        <div class="form-group">
                            <label>Enviar emails</label>
                            <input type="email" v-model="analise.email" class="form-control">
                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-4">
                        <div class="form-group">
                            <label>&nbsp;</label>
                            <input type="email" v-model="analise.email2" class="form-control">
                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-4">
                        <div class="form-group">
                            <label>&nbsp;</label>
                            <input type="email" v-model="analise.email3" class="form-control">
                        </div>
                    </div>

                    <div class="col-xs-12 col-sm-4">
                        <div class="form-group">
                            <label>Observações</label>
                            <textarea v-model="analise.observacao" class="form-control"></textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="block" v-if="gravaLog">
            <div class="block-title">
                <h5>Informações log</h5>
            </div>

            <div class="row">
                <div class="col-xs-12 col-sm-4">
                    <div class="form-group">
                        <label>Solicitante</label>
                        <input type="text" v-model="analiseLog.solicitante" class="form-control" placeholder="Nome" size="10"/>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-4">
                    <div class="form-group">
                        <label>Observações log</label>
                        <textarea v-model="analiseLog.observacoes" class="form-control"></textarea>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-4">
                    <div class="form-group">
                        <label>Arquivo</label>
                        <input type="file" @change="setArquivoLog($event)">
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                    <button type="submit" class="btn btn-success">Salvar</button>
                    &nbsp;
                    <router-link :to="{name: 'analises'}" class="btn btn-danger">Cancelar</router-link>
                </div>
            </div>
        </div>

        <div class="row" v-if="analise.tipo != undefined && analise.tipo.value != 'SOLO' && !editando">
            <div class="col-xs-12">
                <h3 class="title">Resultado</h3>
            </div>
        </div>

        <div class="row" v-if="analise.tipo != undefined && !editando">
            <div v-if="analise.tipo.value === 'SEMENTE'">
                <div class="col-xs-12 col-md-4" v-if="analise.semente_germinacao">
                    <div class="form-group">
                        <label>Germinação (%)</label>
                        <input type="text" onClick="this.select();" v-model="analise.resultado.germinacao"
                               class="form-control" data-vv-name="germinação"/>
                    </div>
                </div>
                <div class="col-xs-12 col-md-4" v-if="analise.semente_vigor">
                    <div class="form-group">
                        <label>Vigor (%)</label>
                        <input type="text" onClick="this.select();" v-model="analise.resultado.vigor"
                               class="form-control" data-vv-name="vigor"/>
                    </div>
                </div>
                <div class="col-xs-12 col-md-4">
                    <div class="form-group">
                        <label>Pureza (%)</label>
                        <input type="text" onClick="this.select();" v-model="analise.resultado.pureza"
                               class="form-control" data-vv-name="pureza"/>
                    </div>
                </div>
                <div class="col-xs-12 col-md-4">
                    <div class="form-group">
                        <label>Peso de mil sementes (gramas) </label>
                        <input type="text" onClick="this.select();" v-model="analise.resultado.peso_mil_sementes"
                               class="form-control" data-vv-name="peso"/>
                    </div>
                </div>
            </div>
            <div v-if="analise.tipo.value === 'TECIDO'">
                <div class="col-xs-12 col-sm-6 form-inline">
                    <div class="row">
                        <div class="col-xs-5">Nitrogênio (%)</div>
                        <div class="col-xs-3"><input type="text" onClick="this.select();"
                                                        v-model="analise.resultado.nitrogenio" class="form-control"
                                                        @input="calculaAvaliacao('nitrogenio', analise.resultado.nitrogenio)"
                                                        data-vv-name="nitrogênio"/></div>
                        <div class="col-xs-4"><input type="text" class="form-control"
                                                        v-model="analise.resultado.nitrogenio_avaliacao" readonly></div>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-6 form-inline">
                    <div class="row">
                        <div class="col-xs-5">Fósforo (%)</div>
                        <div class="col-xs-3"><input type="text" onClick="this.select();"
                                                        v-model="analise.resultado.fosforo" class="form-control"
                                                        @input="calculaAvaliacao('fosforo', analise.resultado.fosforo)"
                                                        data-vv-name="fósforo"/></div>
                        <div class="col-xs-4"><input type="text" class="form-control"
                                                        v-model="analise.resultado.fosforo_avaliacao" readonly></div>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-6 form-inline">
                    <div class="row">
                        <div class="col-xs-5">Potássio (%)</div>
                        <div class="col-xs-3"><input type="text" onClick="this.select();"
                                                        v-model="analise.resultado.potassio" class="form-control"
                                                        @input="calculaAvaliacao('potassio', analise.resultado.potassio)"
                                                        data-vv-name="potássio"/></div>
                        <div class="col-xs-4"><input type="text" class="form-control"
                                                        v-model="analise.resultado.potassio_avaliacao" readonly></div>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-6 form-inline">
                    <div class="row">
                        <div class="col-xs-5">Cálcio (%)</div>
                        <div class="col-xs-3"><input type="text" onClick="this.select();"
                                                        v-model="analise.resultado.calcio" class="form-control"
                                                        @input="calculaAvaliacao('calcio', analise.resultado.calcio)"
                                                        data-vv-name="cálcio"/></div>
                        <div class="col-xs-4"><input type="text" class="form-control"
                                                        v-model="analise.resultado.calcio_avaliacao" readonly></div>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-6 form-inline">
                    <div class="row">
                        <div class="col-xs-5">Magnésio (%)</div>
                        <div class="col-xs-3"><input type="text" onClick="this.select();"
                                                        v-model="analise.resultado.magnesio" class="form-control"
                                                        @input="calculaAvaliacao('magnesio', analise.resultado.magnesio)"
                                                        data-vv-name="magnésio"/></div>
                        <div class="col-xs-4"><input type="text" class="form-control"
                                                        v-model="analise.resultado.magnesio_avaliacao" readonly></div>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-6 form-inline">
                    <div class="row">
                        <div class="col-xs-5">Enxofre (%)</div>
                        <div class="col-xs-3"><input type="text" onClick="this.select();"
                                                        v-model="analise.resultado.enxofre" class="form-control"
                                                        @input="calculaAvaliacao('enxofre', analise.resultado.enxofre)"
                                                        data-vv-name="enxofre"/></div>
                        <div class="col-xs-4"><input type="text" class="form-control"
                                                        v-model="analise.resultado.enxofre_avaliacao" readonly></div>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-6 form-inline">
                    <div class="row">
                        <div class="col-xs-5">Zinco (mg/kg)</div>
                        <div class="col-xs-3"><input type="text" onClick="this.select();" v-model="analise.resultado.zinco"
                                                        class="form-control"
                                                        @input="calculaAvaliacao('zinco', analise.resultado.zinco)"
                                                        data-vv-name="zinco"/></div>
                        <div class="col-xs-4"><input type="text" class="form-control"
                                                        v-model="analise.resultado.zinco_avaliacao" readonly></div>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-6 form-inline">
                    <div class="row">
                        <div class="col-xs-5">Manganês (mg/kg)</div>
                        <div class="col-xs-3"><input type="text" onClick="this.select();"
                                                        v-model="analise.resultado.manganes" class="form-control"
                                                        @input="calculaAvaliacao('manganes', analise.resultado.manganes)"
                                                        data-vv-name="manganês"/></div>
                        <div class="col-xs-4"><input type="text" class="form-control"
                                                        v-model="analise.resultado.manganes_avaliacao" readonly></div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-6 form-inline">
                    <div class="row">
                        <div class="col-xs-5">Boro (mg/kg)</div>
                        <div class="col-xs-3"><input type="text" onClick="this.select();" v-model="analise.resultado.boro"
                                                        class="form-control"
                                                        @input="calculaAvaliacao('boro', analise.resultado.boro)"
                                                        data-vv-name="boro"/></div>
                        <div class="col-xs-4"><input type="text" class="form-control"
                                                        v-model="analise.resultado.boro_avaliacao" readonly></div>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-6 form-inline">
                    <div class="row">
                        <div class="col-xs-5">Sódio (mg/kg)</div>
                        <div class="col-xs-3"><input type="text" onClick="this.select();" v-model="analise.resultado.sodio"
                                                        class="form-control"
                                                        @input="calculaAvaliacao('sodio', analise.resultado.sodio)"
                                                        data-vv-name="sódio"/></div>
                        <div class="col-xs-4"><input type="text" class="form-control"
                                                        v-model="analise.resultado.sodio_avaliacao" readonly></div>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-6 form-inline">
                    <div class="row">
                        <div class="col-xs-5">Ferro (mg/kg)</div>
                        <div class="col-xs-3"><input type="text" onClick="this.select();" v-model="analise.resultado.ferro"
                                                        class="form-control"
                                                        @input="calculaAvaliacao('ferro', analise.resultado.ferro)"
                                                        data-vv-name="ferro"/></div>
                        <div class="col-xs-4"><input type="text" class="form-control"
                                                        v-model="analise.resultado.ferro_avaliacao" readonly></div>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-6 form-inline">
                    <div class="row">
                        <div class="col-xs-5">Cobre (mg/kg)</div>
                        <div class="col-xs-3">
                            <input type="text" v-model="analise.resultado.cobre" class="form-control"/>
                        </div>
                    </div>
                </div>
                
                <div class="col-xs-12">
                    <div class="text-center">
                        <h4>Elementos adicionais</h4>
                    </div>
                </div>
                
                <div class="col-xs-12 col-sm-6 form-inline">
                    <div class="row">
                        <div class="col-xs-5">Primeiro elemento</div>
                        <div class="col-xs-4">
                            <input type="text" v-model="analise.resultado.desc_elemento_adicional_um" class="form-control" placeholder="Descrição"/>
                        </div>
                        <div class="col-xs-3">
                            <input type="text" v-model="analise.resultado.vlr_elemento_adicional_um" class="form-control" placeholder="Valor (mg/KG)"/>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-5">Segundo elemento</div>
                        <div class="col-xs-4">
                            <input type="text" v-model="analise.resultado.desc_elemento_adicional_dois" class="form-control" placeholder="Descrição"/>
                        </div>
                        <div class="col-xs-3">
                            <input type="text" v-model="analise.resultado.vlr_elemento_adicional_dois" class="form-control" placeholder="Valor (mg/KG)"/>
                        </div>
                    </div>
                </div>
                <BR/>
            </div>
            <div v-if="analise.tipo.value === 'FERTILIZANTE'">
                <div class="col-xs-12 col-md-4">
                    <div class="form-group">
                        <label>Nitrogênio (%)</label>
                        <input type="text" onClick="this.select();" v-model="analise.resultado.nitrogenio_resultado"
                            class="form-control" data-vv-name="nitrogênio"/>
                    </div>
                </div>
                <div class="col-xs-12 col-md-4">
                    <div class="form-group">
                        <label>Fósforo (%)</label>
                        <input type="text" onClick="this.select();" v-model="analise.resultado.fosforo_resultado"
                            class="form-control" data-vv-name="fósforo"/>
                    </div>
                </div>
                <div class="col-xs-12 col-md-4">
                    <div class="form-group">
                        <label>Potássio (%)</label>
                        <input type="text" onClick="this.select();" v-model="analise.resultado.potassio_resultado"
                            class="form-control" data-vv-name="potássio"/>
                    </div>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
    import VcPesquisa from "@/components/Form/Pesquisa";
    import Datepicker from "@/components/Form/Datepicker";

    import VcAdicionaPessoa from "./AdicionarPessoas";
    import VcMostraMensagemValidacao from "@/components/Form/MostraMensagemValidacao";

    import VcFormPessoa from "@/views/Pessoas/FormExterno";
    import armazenaPedido from "./services/armazenar_pedido";
    import aplicaPreco from "./services/aplica_preco";

    import { VueSelect } from "vue-select";

    import Bus from "../../bus";

    export default {
        name: "form-analises",
        components: {
            VcPesquisa,
            VcAdicionaPessoa,
            VcMostraMensagemValidacao,
            VcFormPessoa,
            Datepicker,
            VueSelect
        },

        data() {
            return {
                modo: null,
                foto: null,
                exibeFormBuscaAnalise: {
                    site: false,
                    sistemaAntigo: false
                },
                analiseSistemaAntigo: {},
                analiseOriginal: null,
                proprietarios: [],
                arrendatarios: [],
                documento: {
                    FATURADA: false,
                    NFATURAR: false,
                    BOLETO: false
                },
                analiseLog: {},
                analise: {
                    tipo: {label: "Solo", value: "SOLO"},
                    laudo_financiamento: {label: "Sim", value: "1"},
                    boleto: {label: "Remetente", value: "REMETENTE"},
                    solo: {},
                    emitir_nota: false,
                    tecido: {},
                    semente: {},
                    fertilizante: {},
                    resultado: {},
                    analisa_ph_calc2: false,
                    analisa_fosforo_resina: false,
                    analisa_ferro: false,
                    analisa_condutividade: false,
                    analisa_nitrogenio_azoto: false,
                    analisa_silicio: false,
                },
                extraCultura: {}, //componente pesquisa
                precoRemetente: {},
                subsidio: {
                    temSubsidio: false,
                    alterou: false
                },
                subsidio_sebrae: {
                    temSubsidio: false,
                    alterou: false
                },
                analisesProprietarioSebrae: [],
                subsidio_temp: false
            };
        },

        computed: {
            podeEditarPagamentos() {
                if (this.$store.state.Form.toEdit != null && this.$store.state.Form.toEdit != undefined) {
                    return (this.$store.state.Form.toEdit.forma_pagamento != 'BOLETO' && this.editando) || !this.editando
                }
                return true
            },

            editando() {
                return this.$route.name == 'analises.editar'
            },
            extraRemetente() {
                return {
                    fornecedor: 1,
                    cliente: 1
                };
            },

            configuracao() {
                return this.$store.state.Empresa.configuracao;
            },

            gravaLog() {
                return this.analise.data_resultado != null
            }
        },

        watch: {
            /**
             limpa campos desnecessários
             */
            "subsidio.alterou"(value) {
                this.$set(this.analise, 'subsidio', value ? '1' : '0');

                if (value) {
                    this.$set(this.analise, 'subsidio_sebrae', '0');
                    this.$set(this.subsidio_sebrae, 'alterou', false);
                }

                this.aplicarTabela()
            },

            "subsidio_sebrae.alterou"(value) {
                this.$set(this.analise, 'subsidio_sebrae', value ? '1' : '0');

                if (value) {
                    this.$set(this.analise, 'subsidio', '0');
                    this.$set(this.subsidio, 'alterou', false);
                }

                this.aplicarTabela()
            },

            "documento.FATURADA"(value) {
                if (value) {
                    this.$set(this.documento, 'NFATURAR', false)
                    this.$set(this.documento, 'BOLETO', false)
                    this.controlaDocumento('FATURADA');
                }
            },

            "documento.NFATURAR"(value) {
                if (value) {
                    this.$set(this.documento, 'FATURADA', false)
                    this.$set(this.documento, 'BOLETO', false)
                    this.$set(this.analise, 'emitir_nota', false)
                    this.controlaDocumento('NFATURAR');
                }
            },

            "analise.solo_quimica"(value){
                if(!value) {
                    this.$set(this.analise, 'analisa_ph_calc2', false)
                    this.$set(this.analise, 'analisa_fosforo_resina', false)
                    this.$set(this.analise, 'analisa_ferro', false)
                    this.$set(this.analise, 'analisa_condutividade', false)
                    this.$set(this.analise, 'analisa_nitrogenio_azoto', false)
                    this.$set(this.analise, 'analisa_silicio', false)
                    this.$set(this.analise, 'pacote_elementos_1', false)
                }
            },

            "documento.BOLETO"(value) {
                if (value) {
                    this.$set(this.documento, 'NFATURAR', false)
                    this.$set(this.documento, 'FATURADA', false)
                    this.controlaDocumento('BOLETO');
                }
            },

            "analise.tipo"(objeto) {
                if (objeto.value !== 'SEMENTE') {
                    this.$set(this.analise, 'semente_germinacao', false)
                    this.$set(this.analise, 'semente_vigor', false)
                }

                if (objeto.value !== 'SOLO') {
                    this.$set(this.analise, 'solo_extrato_saturacao', false)
                    this.$set(this.analise, 'solo_fisica', false)
                    this.$set(this.analise, 'solo_quimica', false)
                }

                this.$set(this, "extraCultura", {tipoAnalise: objeto.value});
                this.controlaDataPrevisao(objeto.value)
                this.aplicarTabela();
            }
        },

        methods: {

            positivosApenasInicial(event) {
                const value = event.target.value.replace(/[^0-9]/g, "");
                this.analise.solo.profundidade_coleta_inicial = value;
            },

            positivosApenasFinal(event) {
                const value = event.target.value.replace(/[^0-9]/g, "");
                this.analise.solo.profundidade_coleta_final = value;
            },

            controlaDocumento(documento) {
                let data = new Date()

                if (documento === "FATURADA") {
                    this.$set(this.analise, "faturado", '1');
                    this.$set(
                        this.analise,
                        "data_pagamento",
                        data.toISOString().substr(0, 10)
                    );
                } else {
                    this.$set(this.analise, "faturado", '0');
                    this.$set(this.analise, "data_pagamento", "");
                    let dias = this.precoRemetente != null && this.precoRemetente.dias_vencimento_boleto > 0 ? this.precoRemetente.dias_vencimento_boleto : 30

                    data.setDate(data.getDate() + parseInt(dias));
                    this.$set(this.analise, "data_vencimento", data.toISOString().substr(0, 10));
                }

                this.$set(this.analise, 'documento', documento)
                this.$set(this.analise, 'forma_pagamento', documento)
            },

            buscaAnaliseSite() {
                window.swal({
                    title: "Buscando analise",
                    imageUrl: require("@/assets/logo.png"),
                    imageWidth: "100px",
                    animation: false,
                    allowOutsideClick: false,
                    onOpen: () => {
                        window.swal.showLoading();
                        this.$http.post("api/analises/getSite/", this.analiseSistemaAntigo).then((response) => {
                            let analise = response.data.analise
                            if (analise == null) {
                                window.swal("Atenção", "Nenhuma analise encontrada com o seguinte código " + this.analiseSistemaAntigo.codigoSite, "warning");
                                return false;
                            }
                            this.$router.push({name: "analises", params: {analiseEditar: analise.id}})
                            window.swal("Sucesso", "Análise encontrada!", "success")
                        })
                    }
                });
            },

            buscaAnaliseSistemaAntigo() {
                window.swal({
                    title: "Buscando analise",
                    imageUrl: require("@/assets/logo.png"),
                    imageWidth: "100px",
                    animation: false,
                    allowOutsideClick: false,
                    onOpen: () => {
                        window.swal.showLoading();
                        this.$http.post("api/analises/getAntiga/", this.analiseSistemaAntigo).then((response) => {
                            let analise = response.data.analise

                            if (response.data.erro == 1) {
                                window.swal("Atenção", "Erro ao processar seu pedido " + response.data.mensagem, "warning");
                                return false;
                            }

                            if (response.data.analise == undefined || response.data.analise == null) {
                                window.swal("Atenção", "Nenhuma analise encontrada com o seguinte registro " + this.analiseSistemaAntigo.numeroRegistro + ' / ' + this.analiseSistemaAntigo.numeroRegistroAno, "warning");
                                return false;
                            }

                            if (analise.solo.profundidade_coleta_final != null) {
                                analise.solo.profundidade_coleta_final = analise.solo.profundidade_coleta_final
                            }

                            if (analise.solo.profundidade_coleta_inicial != null) {
                                analise.solo.profundidade_coleta_inicial = analise.solo.profundidade_coleta_inicial
                            }

                            this.$set(this.analise, 'solo', analise.solo)
                            this.$set(this.analise, 'remetente', analise.remetente)
                            this.$set(this.analise, 'cidade', analise.municipio_amostra == undefined ? analise.cidade : analise.municipio_amostra)
                            this.$set(this.analise, 'solo_quimica', analise.solo_quimica == '1' ? true : false)
                            this.$set(this.analise, 'solo_fisica', analise.solo_fisica == '1' ? true : false)
                            this.$set(this.analise, 'solo_extrato_saturacao', analise.solo_extrato_saturacao == '1' ? true : false)
                            this.$set(this, 'proprietarios', analise.proprietarios)
                            this.$set(this, 'arrendatarios', analise.arrendatarios)
                            window.swal("Sucesso", "Análise encontrada!", "success")
                        }).catch(error => {
                            return window.swal("Atenção", "Houve um problema ao buscar a analise. <br><br>" + error.response.data.mensagem, "warning");
                        });
                    }
                });
            },

            selecinouRemetente(remetente) {
                this.$set(this.analise, "remetente_id", remetente.id);
                this.$set(this.analise, "remetente", remetente);
                this.$set(this, "precoRemetente", remetente.preco != null ? remetente.preco : {});

                if (!this.editando || parseInt(this.analise.site)) {
                    if (remetente.preco != null) {
                        if (remetente.preco.forma_pagamento_padrao == '') {
                            this.limpaFormas()
                        } else {
                            this.$set(this.documento, remetente.preco.forma_pagamento_padrao, true);
                        }
                        this.$set(this.analise, 'boleto', {
                            value: remetente.preco.boleto_para,
                            label: (remetente.preco.boleto_para == 'REMETENTE' ? 'Remetente' : (remetente.preco.boleto_para == 'ARRENDATARIO' ? "Proprietário / Cedente" : 'Produtor / Proprietário'))
                        })
                        this.$set(this.analise, 'gera_boleto', {
                            value: remetente.preco.gera_boleto,
                            label: (remetente.preco.gera_boleto == 'PROTOCOLO' ? 'Protocolo' : 'Resultado')
                        })

                    } else if (!this.editando) {
                        this.limpaFormas()
                    }

                    if (remetente.preco != null && remetente.preco.forma_pagamento_padrao != null) {
                        this.controlaDocumento(remetente.preco.forma_pagamento_padrao)
                    }
                }

                this.aplicarTabela();
            },

            limpaFormas() {
                this.$set(this.documento, 'BOLETO', false);
                this.$set(this.documento, 'NFATURAR', false);
                this.$set(this.documento, 'FATURADa', false);
            },

            aplicarTabela() {
                aplicaPreco.aplicar(this);
            },

            changeElementos1() {
                const valor = this.analise.pacote_elementos_1;

                this.analise.analisa_ph_calc2 = valor;
                this.analise.analisa_fosforo_resina = valor;
                this.analise.analisa_ferro = valor;
                this.analise.analisa_condutividade = valor;
                this.analise.analisa_nitrogenio_azoto = valor;
                this.analise.analisa_silicio = valor;
                this.aplicarTabela();
            },

            verificaElementos1(){
                if (this.analise.analisa_ph_calc2 &&
                    this.analise.analisa_fosforo_resina &&
                    this.analise.analisa_ferro &&
                    this.analise.analisa_condutividade &&
                    this.analise.analisa_nitrogenio_azoto &&
                    this.analise.analisa_silicio) {
                        this.$set(this.analise, 'pacote_elementos_1', true);
                    } else {
                        this.$set(this.analise, 'pacote_elementos_1', false);
                    }
                this.aplicarTabela();
            },

            setArquivoLog(event) {
                this.$set(this.analiseLog, 'arquivo', event.target.files[0]);
            },

            setFoto(event) {
                this.foto = event.target.files[0];
            },

            setCidade(cidade) {
                this.$set(this.analise, 'cidade_id', cidade.id)
                this.$set(this.analise, 'cidade', cidade)
            },

            controlaPromise(promise) {
                let self = this;
                return promise.then(async response => {
                    let analise = response.data.analise;

                    if (analise == null) {
                        window.swal("Atenção", "Erro ao cadastrar analise. \r\n" + response.data.mensagem, "warning");
                        return false;
                    }

                    if (self.analise.tipo.value != 'SOLO' && !self.editando && Object.keys(self.analise.resultado).length != 0 && self.analise.documento == "BOLETO") self.analise.gera_boleto.value = 'PROTOCOLO';

                    if ((self.analise.documento == "BOLETO" && self.analise.gera_boleto.value == 'PROTOCOLO' && self.analise.pedido_id == null) || (self.analise.documento == "FATURADA" && self.analise.emitir_nota)) {
                        this.$set(this.analise, 'proprietarios', this.proprietarios);
                        await armazenaPedido.enviar([Object.assign({}, this.analise, analise)], this.proprietarios);

                        if (self.analise.documento == "BOLETO") {
                            await this.$http.get("api/analises/get-boleto/" + analise.id, {'enviaEmail': false}).then(response => {
                                if (response.data.pdf != null) {
                                    let a = document.createElement("a");
                                    a.href = "data:application/octet-stream;base64," + response.data.pdf;
                                    a.download = "Boleto_" + analise.tipo + "_" + analise.registro + "_" + analise.ano_registro + ".pdf";
                                    a.click();
                                }
                            });
                        }

                        if (self.analise.emitir_nota) {
                            await this.$http.get("api/analises/get-nfse/" + analise.id, {'enviaEmail': false}).then(response => {
                                if (response.data.pdf != null) {
                                    let a = document.createElement("a");
                                    a.href = "data:application/octet-stream;base64," + response.data.pdf;
                                    a.download = "NFSe_" + analise.tipo + "_" + analise.registro + "_" + analise.ano_registro + ".pdf";
                                    a.click();
                                }
                            });
                        }
                    }

                    await this.$http.post("api/analises/mail/" + analise.id);

                    if (self.foto != null) {
                        let formData = new FormData();
                        formData.append("foto", self.foto);
                        formData.append("analises_sebrae", JSON.stringify(self.analise.analises_sebrae));

                        await self.$http.post(
                            "api/analises/foto/" + response.data.analise.id,
                            formData,
                            {
                                headers: {"Content-Type": "multipart/form-data"}
                            }
                        );
                    }

                    if (response.data.analiseLog != null) {
                        let formData = new FormData();
                        formData.append("arquivo", self.analiseLog.arquivo);

                        await self.$http.post("api/analises-log/arquivo/" + response.data.analiseLog.id,
                            formData,
                            {
                                headers: {"Content-Type": "multipart/form-data"}
                            }
                        );
                    }

                    window.swal("Sucesso", "Análise armazenada com sucesso!", "success").then(() => {
                        if (self.modo === "editar") {
                            return self.$router.push({name: "analises"});
                        }
                        window.swal({
                            title: "Adicionar nova análise",
                            text: "Deseja adicionar uma nova análise?",
                            type: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#3085d6",
                            cancelButtonColor: "#d33",
                            confirmButtonText: "Sim",
                            cancelButtonText: "Não"
                        })
                            .then(result => {
                                if (result.value) {
                                    // do nothing
                                } else {
                                    self.novaAnalise()
                                }
                            });
                    });
                })
            },

            calculaAvaliacao(campo) {

                let cultura = this.analise.cultura
                if(cultura == undefined){
                    return window.swal("Atenção", "Selecione uma cultura antes de continuar.", "warning");
                }
                let valor = this.analise.resultado[campo];

                // default
                this.$set(this.analise.resultado, (campo + '_avaliacao'), 'Deficiente')

                if (parseFloat(valor) <= parseFloat(cultura[campo + "_d_max"].replace(',', '.'))) {
                    this.$set(this.analise.resultado, (campo + '_avaliacao'), 'Deficiente')
                }
                if (parseFloat(valor) >= parseFloat(cultura[campo + "_n_min"].replace(',', '.')) && parseFloat(valor) <= parseFloat(cultura[campo + "_n_max"].replace(',', '.'))) {
                    this.$set(this.analise.resultado, (campo + '_avaliacao'), 'Normal')
                }
                if (parseFloat(valor) >= parseFloat(cultura[campo + "_a_min"].replace(',', '.'))) {
                    this.$set(this.analise.resultado, (campo + '_avaliacao'), 'Alto')
                }
            },

            preencheCultura(cultura){
                this.$set(this.analise, 'cultura', cultura);
                this.$set(this.analise, 'cultura_id', cultura.id)
            },

            novaAnalise() {
                let tipo = this.analise.tipo
                this.$set(this, "analise", {});
                this.$set(this, "analiseSistemaAntigo", {});

                this.$set(this.analise, 'tipo', tipo)
                this.$set(this.analise, 'laudo_financiamento', {label: "Sim", value: "1"})
                this.$set(this.analise, 'boleto', {label: "Remetente", value: "REMETENTE"})
                this.$set(this.analise, 'solo', {})
                this.$set(this.analise, 'tecido', {})
                this.$set(this.analise, 'emitir_nota', false)
                this.$set(this.analise, 'semente', {})
                this.$set(this.analise, 'fertilizante', {})
                this.$set(this.analise, 'resultado', {})
                this.$set(this, 'documento', {'FATURADA': false, 'NFATURAR': false, 'boleto': false})


                this.$set(this, 'proprietarios', [])
                this.$set(this, 'arrendatarios', [])
                this.$set(this, "modo", "adicionar");

                this.controlaDataPrevisao(this.analise.tipo.value);

                let data = new Date();
                this.$set(this.analise, "data_registro", data.toISOString().substr(0, 10));
                data.setDate(data.getDate() - 7);

                this.$set(this.analise, "faturado", '1');
                this.$set(this.analise, "data_pagamento", data.toISOString().substr(0, 10));

                data.setDate(data.getDate() + 30);
                this.$set(this.analise, "data_vencimento", data.toISOString().substr(0, 10));
                Bus.$emit('limpa-select')
                $('html,body').animate({scrollTop: 0}, 'slow');
            },

            controlaDataPrevisao(tipo) {
                let data = new Date();

                if (tipo == 'SOLO' && parseInt(this.configuracao.previsao_solo) > 0) {
                    data.setDate(data.getDate() + parseInt(this.configuracao.previsao_solo));
                } else if (tipo == 'SEMENTE' && parseInt(this.configuracao.previsao_semente) > 0) {
                    data.setDate(data.getDate() + parseInt(this.configuracao.previsao_semente));
                } else if (tipo == 'TECIDO' && parseInt(this.configuracao.previsao_tecido_vegetal) > 0) {
                    data.setDate(data.getDate() + parseInt(this.configuracao.previsao_tecido_vegetal));
                } else if (tipo == 'FERTILIZANTE' && parseInt(this.configuracao.previsao_fertilizante) > 0) {
                    data.setDate(data.getDate() + parseInt(this.configuracao.previsao_fertilizante));
                } else {
                    data.setDate(data.getDate() + 7);
                }

                this.$set(this.analise, "data_previsao_conclusao", data.toISOString().substr(0, 10));
            },

            async validaDestinatarioBoleto() {
                if (!this.documento.BOLETO) {
                    return true
                }
                let destino = this.analise.boleto.value
                let pessoa = null

                if (destino == 'REMETENTE' && this.analise.remetente != null) {
                    pessoa = this.analise.remetente
                } else if (destino == 'PROPRIETARIO' && this.proprietarios[0] != null) {
                    pessoa = this.proprietarios[0]
                } else if (destino == 'ARRENDATARIO' && this.arrendatarios[0] != null) {
                    pessoa = this.arrendatarios[0]
                }

                pessoa = this.validaCpfCnpj(pessoa)
                if (!pessoa) {
                    window.swal("Atenção", "Informe o CPF / CNPJ do destinatário do boleto antes de continuar.", "warning");
                    return false;
                }

                let data = null
                if (pessoa.endereco == null || pessoa.endereco == '' || pessoa.bairro == null || pessoa.bairro == '' || pessoa.cep == null || pessoa.cep == '' || pessoa.cidade_id == null) {
                    if (destino == 'REMETENTE' || ((destino == 'PROPRIETARIO' || destino == 'ARRENDATARIO') && (this.analise.remetente.endereco == null || this.analise.remetente.endereco == '' || this.analise.remetente.bairro == null || this.analise.remetente.bairro == '' || this.analise.remetente.cep == null || this.analise.remetente.cep == '' || this.analise.remetente.cidade_id == null))) {
                        //pega empresa
                        data = {'pessoaAtualizar': pessoa.id, 'pessoaDados': {'empresa': true}}
                    } else {
                        if (this.analise.remetente.endereco == null || this.analise.remetente.endereco == '' || this.analise.remetente.bairro == null || this.analise.remetente.bairro == '' || this.analise.remetente.cep == null || this.analise.remetente.cep == '' || this.analise.remetente.cidade_id == null) {
                            window.swal("Atenção", "Remetente e proprietário sem informações para geração de boleto.", "warning");
                            return false;
                        }

                        //pega remetente
                        data = {
                            'pessoaAtualizar': pessoa.id,
                            'pessoaDados': {'empresa': false, 'remetente': this.analise.remetente}
                        }
                    }

                    await this.$http.post("api/pessoas/atualiza-endereco-cadastro", data)
                }
                this.$set(this.analise, 'pessoa_id', pessoa.id)
                return true
            },

            validaCpfCnpj(pessoa) {
                let tipo = pessoa.tipo
                let pessoaCorreta = false

                if ((tipo == 2 && pessoa.cnpj != null && pessoa.cnpj != '') || (tipo == 1 && pessoa.cpf != null && pessoa.cpf != '')) {
                    return pessoa
                }

                if (this.analise.boleto.value == 'REMETENTE') {
                    return false
                }

                if (this.proprietarios.length > 0 && !pessoaCorreta) {
                    this.proprietarios.forEach((proprietario) => {
                        if (!pessoaCorreta && ((tipo == 2 && proprietario.cnpj != null && proprietario.cnpj != '') || (tipo == 1 && proprietario.cpf != null && proprietario.cpf != ''))) {
                            pessoaCorreta = proprietario;
                        }
                    })
                }

                if (this.arrendatarios.length > 0 && !pessoaCorreta) {
                    this.arrendatarios.forEach((arrendatario) => {
                        if (!pessoaCorreta && ((tipo == 2 && arrendatario.cnpj != null && arrendatario.cnpj != '') || (tipo == 1 && arrendatario.cpf != null && arrendatario.cpf != ''))) {
                            pessoaCorreta = arrendatario;
                        }
                    })
                }

                return pessoaCorreta
            },

            async validaAlteracoes() {
                const self = this

                if (!self.editando || self.analise.site == '1') {
                    return self.armazenar()
                }

                let propDiferente = false
                let arrDiferente = false

                let tinhaProp = (idAtual) => {
                    let temProp = false
                    self.$store.state.Form.toEdit.proprietarios.forEach((propAntigo) => {
                        if (propAntigo.id == idAtual) {
                            temProp = true
                        }
                    })
                    return temProp
                };

                let tinhaArr = (idAtual) => {
                    let temArr = false
                    self.$store.state.Form.toEdit.arrendatarios.forEach((arrAntigo) => {
                        if (arrAntigo.id == idAtual) {
                            temArr = true
                        }
                    })
                    return temArr
                }

                if (self.analise.tipo.value === 'SOLO' && self.$store.state.Empresa.configuracao.senha != null) {
                    await self.analise.proprietarios.forEach((propAtual) => {
                        if (!propDiferente && !tinhaProp(propAtual.id)) {
                            propDiferente = true
                        }
                    })

                    await self.analise.arrendatarios.forEach((arrAtual) => {
                        if (!arrDiferente && !tinhaArr(arrAtual.id)) {
                            arrDiferente = true
                        }
                    })

                    if (self.$store.state.Form.toEdit.forma_pagamento != self.analise.forma_pagamento || self.$store.state.Form.toEdit.subsidio != self.analise.subsidio || (self.analise.arrendatarios.length < self.$store.state.Form.toEdit.arrendatarios.length) || (self.analise.proprietarios.length < self.$store.state.Form.toEdit.proprietarios.length) || (self.analise.solo.area_ha != self.$store.state.Form.toEdit.solo.area_ha) || (self.analise.solo.matricula != self.$store.state.Form.toEdit.solo.matricula) || (self.analise.solo.lote_rural != self.$store.state.Form.toEdit.solo.lote_rural) || (self.analise.solo.localidade != self.$store.state.Form.toEdit.solo.localidade) || (self.analise.cidade.id != self.$store.state.Form.toEdit.cidade.id) || propDiferente || arrDiferente) {
                        window.swal({
                            title: 'Informe a senha.',
                            input: 'password',
                            showCancelButton: true,
                            confirmButtonText: 'Confirmar',
                            cancelButtonText: 'Cancelar',
                            showLoaderOnConfirm: true,
                            preConfirm: (senha) => {
                                if (senha == self.$store.state.Empresa.configuracao.senha) {
                                    self.armazenar()
                                }
                                window.swal.showValidationMessage('Senha inválida.')
                                return false
                            },
                            allowOutsideClick: () => !window.swal.isLoading()
                        }).then((result) => {
                            if (result.dismiss != undefined && (result.dismiss == "cancel" || result.dismiss == "esc" || result.dismiss == "overlay")) {
                                return false
                            }
                        })
                    } else {
                        self.armazenar()
                    }
                } else {
                    self.armazenar()
                }
            },

            async armazenar() {
                let self = this;

                this.$validator.validate().then(async valid => {
                    if (!valid) {
                        return null;
                    }

                    if (this.subsidio_temp && !this.subsidio.alterou && !this.subsidio_sebrae.alterou) {
                        window.swal("Atenção", "Informe um subsídio.", "info");
                        return false;
                    }

                    if (!this.documento.BOLETO && !this.documento.NFATURAR && !this.documento.FATURADA) {
                        window.swal("Atenção", "Informe a forma de pagamento.", "info");
                        return false;
                    }

                    if (this.gravaLog && (this.analiseLog.solicitante == undefined || this.analiseLog.solicitante == '')) {
                        window.swal("Atenção", "Informe o solicitante nas informações de log.", "info");
                        return false;
                    }

                    if ((this.analise.tipo.value === 'SOLO' && (this.analise.solo_quimica == undefined || !this.analise.solo_quimica) && (this.analise.solo_fisica == undefined || !this.analise.solo_fisica) && (this.analise.solo_extrato_saturacao  == undefined || !this.analise.solo_extrato_saturacao)) ||
                        (this.analise.tipo.value === 'SEMENTE' && (this.analise.semente_germinacao == undefined || !this.analise.semente_germinacao) && (this.analise.semente_vigor == undefined || !this.analise.semente_vigor))) {
                        window.swal("Atenção", "Escolha um material a ser analisado antes de finalizar.", "info");
                        return false;
                    }

                    if (this.analise.valor_amostra <= 0) {
                        window.swal("Atenção", "Analise sem valor de amostra", "info");
                        return false;
                    }

                    if (!this.documento.FATURADA && !this.documento.BOLETO && !this.documento.NFATURAR && this.analise.faturado == 0) {
                        window.swal("Atenção", "Informe pelo menos uma forma de pagamento.", "warning");
                        return false;
                    }

                    if (this.documento.BOLETO && this.arrendatarios.length == 0 && this.analise.boleto.value === 'ARRENDATARIO') {
                        window.swal("Atenção", "Selecione um arrendatário ou troque o destino do boleto.", "warning");
                        return false;
                    }

                    if (this.proprietarios.length <= 0) {
                        window.swal("Atenção", "Informe ao menos 01(um) produtor / proprietário", "info");
                        return false;
                    }

                    if (this.analise.remetente_id == null || this.analise.remetente_id <= 0) {
                        window.swal('Atenção', 'Informe um remetente', 'info');
                        return false;
                    }

                    if (this.analise.pedido_id == null && this.analise.emitir_nota && this.analise.documento != 'BOLETO') {
                        this.analise.pessoa_id = this.analise.nfse_para.value === 'REMETENTE' ? this.analise.remetente.id : (this.analise.nfse_para.value === 'ARRENDATARIO' ? this.arrendatarios[0].id : this.proprietarios[0].id)
                    }

                    await self.validaDestinatarioBoleto().then((response) => {
                        if (!response) {
                            return false;
                        } else {
                            let analise = Object.assign({}, self.analise, {
                                arrendatarios: self.arrendatarios,
                                proprietarios: self.proprietarios,
                            });
                            analise.tipo = analise.tipo != null ? analise.tipo.value : null;
                            analise.laudo_financiamento = analise.laudo_financiamento != null ? analise.laudo_financiamento.value : null;
                            analise.boleto = analise.boleto != null ? analise.boleto.value : null;
                            analise.site = '0'

                            if (analise.subsidio == '1' && analise.documento == 'BOLETO') {
                                analise.valor_amostra += 5
                            }

                            if (analise.tipo === 'SOLO') {
                                analise.solo.profundidade_coleta_inicial = (analise.solo.profundidade_coleta_inicial == null ? '' : analise.solo.profundidade_coleta_inicial);
                                analise.solo.profundidade_coleta_final = (analise.solo.profundidade_coleta_final == null ? '' : analise.solo.profundidade_coleta_final);
                            }

                            window.swal({
                                title: "Armazenando análise",
                                imageUrl: require("@/assets/logo.png"),
                                imageWidth: "100px",
                                animation: false,
                                allowOutsideClick: false,
                                onOpen: () => {
                                    window.swal.showLoading();
                                    if (self.modo === "editar") {
                                        self.controlaPromise(
                                            self.$http.put("api/analises/" + analise.id, {
                                                analise: analise,
                                                atualizarDependencia: true,
                                                gravaLog: this.gravaLog,
                                                analiseLog: this.analiseLog
                                            })
                                        );
                                    } else {
                                        self.controlaPromise(
                                            self.$http.post("api/analises", {analise: analise})
                                        );
                                    }
                                }
                            });
                        }
                    })
                });
            },

            async carregaAnalisesProprietario() {
                await this.$http.post('api/carregaAnalisesSebrae/' + this.analise.id).then((response) => {
                    this.$set(this, 'analisesProprietarioSebrae', response.data.analises);
                });
            }
        },

        async mounted() {
            this.$store.dispatch('removeEditingModel')

            await this.$store.dispatch("setConfiguracao");

            if (this.editando) {

                let analise = {}

                await this.$http.get(`api/analises/${this.$route.params.id}`).then((response) => analise = response.data).catch(error => {
                    throw Error(error)
                })
                this.$store.dispatch('setAnalise', this.$route.params.id);

                analise.editando = true
                analise.tipo = {
                    value: analise.tipo,
                    label: analise.tipo[0].toUpperCase() + analise.tipo.slice(1).toLowerCase()
                };
                analise.laudo_financiamento = {
                    value: analise.laudo_financiamento,
                    label: parseInt(analise.laudo_financiamento) ? "Sim" : "Não"
                };
                analise.boleto = {
                    value: analise.boleto,
                    label: analise.boleto === "REMETENTE" ? "Remetente" : (analise.boleto === "ARRENDATARIO" ? "Produtor" : "Proprietário / Cedente")
                };

                if(analise.registro == 0 && analise.ano_registro == 0) {
                    this.$set(this, 'subsidio_temp', analise.subsidio);
                    this.subsidio = {'temSubsidio': false, 'alterou': false}
                    this.subsidio_sebrae = {'temSubsidio': false, 'alterou': false}
                } else {
                    if (analise.subsidio == '1') {
                        this.subsidio = {'temSubsidio': true, 'alterou': '1'}
                    }

                    if (analise.subsidio_sebrae == '1') {
                        this.subsidio_sebrae = {'temSubsidio': true, 'alterou': '1'}
                    }
                }

                if (analise.remetente != null) {
                    this.$set(this, "precoRemetente", analise.remetente.preco != null ? analise.remetente.preco : {});
                }

                this.$set(this.documento, analise.forma_pagamento, true);

                if (analise.pedido_id == null && analise.forma_pagamento == 'BOLETO') {
                    analise.gera_boleto = {value: 'RESULTADO', label: 'Resultado'}
                } else if (analise.pedido_id != null && analise.forma_pagamento == 'BOLETO') {
                    analise.gera_boleto = {value: 'PROTOCOLO', label: 'Protocolo'}
                }

                this.$set(this, "analise", analise);
                this.$set(this, "proprietarios", analise.proprietarios);
                this.$set(this, "arrendatarios", analise.arrendatarios);
                this.$set(this, "modo", "editar");

                if (this.analise.semente == null) {
                    this.analise.semente = {};
                }

                if (this.analise.solo == null) {
                    this.analise.solo = {};
                }

                if (this.analise.tecido == null) {
                    this.analise.tecido = {};
                }

                if (this.analise.fertilizante == null) {
                    this.analise.fertilizante = {};
                }

                this.analiseLog.observacoes = 'ALTERAÇÕES CONFORME SOLICITAÇÃO DO CLIENTE, TOTAL RESPONSABILIDADE TÉCNICA SOBRE A UTILIZAÇÃO DO LAUDO DE REGISTRO ' + this.analise.registro + ' / ' + this.analise.ano_registro + ' . ' + (this.analise.logs_analise.length+1)  + ' DO SOLICITANTE';

                this.carregaAnalisesProprietario(this.analise.id);
            } else {
                this.$set(this, "modo", "adicionar");

                this.controlaDataPrevisao(this.analise.tipo.value);

                let data = new Date();
                this.$set(this.analise, "data_registro", data.toISOString().substr(0, 10));
                data.setDate(data.getDate() - 7);

                this.$set(this.analise, "faturado", '1');
                this.$set(this.analise, "data_pagamento", data.toISOString().substr(0, 10));

                data.setDate(data.getDate() + 30);
                this.$set(this.analise, "data_vencimento", data.toISOString().substr(0, 10));

                this.$set(this.subsidio, 'temSubsidio', false);
                this.$set(this.subsidio, 'alterou', 0);

                this.$set(this.subsidio_sebrae, 'temSubsidio', false);
                this.$set(this.subsidio_sebrae, 'alterou', 0);
            }

            this.$set(this, "extraCultura", {tipoAnalise: this.analise.tipo.value});

            this.$store.dispatch(
                "setTitle",
                this.modo === "editar" ? ("Editar análise - " + this.analise.registro + ' / ' + this.analise.ano_registro) : "Adicionar análise"
            );
        }
    };
</script>
